/**
 * The stored form of a typed Blocked URL (contract: firebase-schema.md, config/blocked_urls):
 * trimmed, with an http:// or https:// scheme and any trailing "/" taken off and the host
 * lowercased, the path as typed. "example.com", "https://example.com", "example.com/" and
 * "Example.COM" are all stored as "example.com", the same form as "Ban current domain". The
 * tablet ignores the scheme, a leading "www.", a trailing "/" and the host's case when matching.
 */
export const toBlockedUrlEntry = (url: string): string => {
  const entry = url.trim().replace(/^https?:\/\//i, '').replace(/\/+$/, '');
  const hostEnd = entry.search(/[/?#]/);
  const end = hostEnd === -1 ? entry.length : hostEnd;
  return entry.slice(0, end).toLowerCase() + entry.slice(end);
};
